module.exports = __webpack_public_path__ + "static/img/bankofamerica.1cd7378.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/thumbs/bankofamerica.jpg
// module id = 30
// module chunks = 1